import React from 'react'

import BodyText from '../body-text/body-text.component'

import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

const BodyTimestamp = ({ item }) => {
  const { timestamp } = item

  const intl = useIntl()

  const formatTime = timeData => {
    if (!timestamp) {
      return 'Not provided'
    }
    const timeFormat = dayjs(timeData).locale(intl.locale)

    const timeString = `${timeFormat.format('LT')}`
    const dateString = `on ${timeFormat.format('LL')}`
    return `${timeString} ${dateString}`
  }

  const formattedItem = {
    ...item,
    text: formatTime(timestamp)
  }

  return <BodyText item={formattedItem} />
}

export default BodyTimestamp
